import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["variantSelect", "salePrice", "supplyPrice", "stock", "unitPrice", "quantity", "totalPrice", "itemEarning"]

  connect() {
    // If variant is already selected, populate the prices
    if (this.variantSelectTarget.value) {
      this.populatePrices(parseInt(this.variantSelectTarget.value))
    }
    this.calculate()
  }

  variantChanged(event) {
    const variantId = parseInt(event.target.value)
    this.populatePrices(variantId)
    this.calculate()
  }

  populatePrices(variantId) {
    const variants = this.variants
    const variant = variants.find(v => v.id === variantId)

    if (variant) {
      this.salePriceTarget.value = variant.sale_price.toFixed(2)
      this.supplyPriceTarget.value = variant.supply_price.toFixed(2)
      this.stockTarget.value = variant.stock

      // Auto-fill unit_price with sale price if empty
      if (!this.unitPriceTarget.value) {
        this.unitPriceTarget.value = variant.sale_price.toFixed(2)
      }
    } else {
      this.salePriceTarget.value = ""
      this.supplyPriceTarget.value = ""
      this.stockTarget.value = ""
    }
  }

  calculate() {
    const unitPrice = parseFloat(this.unitPriceTarget.value) || 0
    const supplyPrice = parseFloat(this.supplyPriceTarget.value) || 0
    const quantity = parseInt(this.quantityTarget.value) || 0

    const total = unitPrice * quantity
    const earningPerItem = unitPrice - supplyPrice
    const totalEarning = earningPerItem * quantity

    this.totalPriceTarget.value = total.toFixed(2)
    this.itemEarningTarget.value = totalEarning.toFixed(2)

    // Dispatch event for summary controller to update totals
    this.dispatch("calculated", { detail: { total, earning: totalEarning } })
  }

  get variants() {
    if (this._variants) {
      return this._variants
    }

    const summaryContainer = this.element.closest("[data-order-summary-variants-value]")
    const rawVariants = summaryContainer?.dataset?.orderSummaryVariantsValue

    if (!rawVariants) {
      this._variants = []
      return this._variants
    }

    try {
      this._variants = JSON.parse(rawVariants)
    } catch (_error) {
      this._variants = []
    }

    return this._variants
  }
}
